export default "__VITE_ASSET__DRvBfGUt__"